import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [ids, setIds] = useState(new Set());
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    if (!user) { setItems([]); setIds(new Set()); return; }
    setLoading(true);
    try {
      const { data } = await api.get("/wishlist");
      setItems(data);
      setIds(new Set(data.map((i) => i.id)));
    } finally { setLoading(false); }
  };

  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [user?.id]);

  const toggle = async (itemId) => {
    if (!user) return false;
    if (ids.has(itemId)) {
      await api.delete(`/wishlist/${itemId}`);
    } else {
      await api.post(`/wishlist/${itemId}`);
    }
    await refresh();
    return !ids.has(itemId);
  };

  const has = (id) => ids.has(id);

  return (
    <WishlistContext.Provider value={{ items, ids, has, toggle, refresh, loading }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
